import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DocumentUploadDialog from '../../dialogs/components/DocumentUploadDialog';
import './CreateProtocolButton.scss';

const CreateProtocolButton: React.FC = () => {
  const navigate = useNavigate();
  const [showPdfDialog, setShowPdfDialog] = useState(false);

  const handleCreateProtocol = () => {
    navigate('/protocols/create');
  };

  const handleCreateFromPdf = () => {
    setShowPdfDialog(true);
  };

  return (
    <div className='create-protocol-group d-flex flex-column gap-2'>
      <h3 className='mb-0 create-protocol-title'>
        Создать шаблон протокола
      </h3>
      <div className="create-protocol-buttons">
        <button
          className="button-secondary pdf-button"
          onClick={handleCreateFromPdf}
          aria-label="Создать шаблон из документа PDF"
          type="button"
        >
          Из документа
        </button>
        <button
          className="button-primary"
          onClick={handleCreateProtocol}
          aria-label="Создать шаблон вручную"
          type="button"
        >
          Вручную
        </button>
      </div>
      
      <DocumentUploadDialog
        isOpen={showPdfDialog}
        onClose={() => setShowPdfDialog(false)}
      />
    </div>
  );
};

export default CreateProtocolButton;

